module.exports = __webpack_public_path__ + "img/point4_screen01.671aac04.jpg";